module.exports = __webpack_public_path__ + "img/ring_y_c_0_1.3bc35396.png";